import SectionHeader from './SectionHeader'
import DashboardMockup from './DashboardMockup'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const featureBullets = {
  0: [
    'Live portfolio value + monthly income at a glance',
    'DRIP snowball projections over 5, 10, and 20 years',
    'Sector allocation and yield-on-cost tracking',
    'Market open/close status with auto-refresh',
  ],
  1: [
    'Up to 30 portfolios (retirement, taxable, DRIP)',
    'Yield, yield-on-cost, and DPS per holding',
    'SnapTrade brokerage sync — no manual entry',
    'CSV import and PDF export for tax records',
  ],
  2: [
    'Ex-dates and pay-dates for all holdings in one view',
    'Monthly and 12-month projected income totals',
    'Upcoming payments sidebar with exact dollar amounts',
    'Email alerts before each ex-date (Premium)',
  ],
  3: [
    'Monthly bar chart — income by month for any year',
    'Yield-on-cost (YoC) analysis per holding',
    'CSV and PDF export — tax-season ready',
    'Year-over-year income growth comparison',
  ],
  4: [
    'Log covered calls and cash-secured puts (CSPs)',
    'Open position tracking with expiry dates and net P&L',
    'Combined Dividends + Options premium income dashboard',
    'Average monthly options income over last 6 months',
  ],
}

export default function DashboardShowcase() {
  const bulletsRef = useScrollAnimation({ childSelector: '.bullet-item', stagger: 0.1 })

  return (
    <section className="bg-white section-padding-sm" id="features">
      <div className="content-max">
        <SectionHeader
          overline="Every tool you need, beautifully built"
          headline="See your income now and 20 years from now"
        />

        <div className="mt-12">
          <DashboardMockup />
        </div>

        {/* Feature Bullets */}
        <div ref={bulletsRef} className="mt-10 grid sm:grid-cols-2 gap-3 max-w-3xl mx-auto">
          {featureBullets[0].map((bullet, i) => (
            <div key={i} className="bullet-item flex items-start gap-2.5">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="mt-0.5 shrink-0">
                <path d="M4 9l3.5 3.5L14 5" stroke="#1B5E20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm text-slate">{bullet}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
